import React from "react";

export default function Placeholder({ title }) {
  return (
    <div className="container my-4">
      <h2>{title}</h2>
      <p>This page is available on the original site, but the content was not linked directly. You can add the content here anytime.</p>
    </div>
  );
}
